<div class="container m-5">
  <div class="d-flex gap-2">
    <mat-form-field appearance="outline">
      <mat-label>Select Financial Year</mat-label>
      <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)">
        <mat-option *ngFor="let year of [2023, 2024, 2025, 2026, 2027, 2028, 2029,2030]" [value]="year">
          {{ year }} - {{ year + 1 }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" [(ngModel)]="startDate">
        <input matEndDate placeholder="End date" [(ngModel)]="endDate">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Submitted By</mat-label>
      <mat-select [(ngModel)]="submittedBy">
        <mat-option value='All'>All Counsellors</mat-option>
        <mat-option *ngFor="let e of counsellors$ | async" [value]="e.userName">{{e.userName}}</mat-option>
      </mat-select>
    </mat-form-field>

    <!--
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Centres</mat-label>
      <mat-select [formControl]="centreControl" multiple [(ngModel)]="selectedCentres">
        <mat-option *ngFor="let c of centres$ | async" [value]="c.centreCode">{{c.centreName}}</mat-option>
        <mat-option value="All">All Centres</mat-option>
      </mat-select>
    </mat-form-field>
-->
    <button mat-mini-fab (click)="search()" permission="Cou. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
      <mat-icon>search</mat-icon>
    </button>

    <button mat-mini-fab (click)="clearFilters()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <p>Note :- <span style="color:red">The financial year selection is only for auto-filling the date range.</span></p>
  <!-- Individual Session Count Report -->
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Individual Session Count Report</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Cou. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <table class="table table-striped table-bordered" id="excel-table">
        <thead>
        <tr>
          <th scope="col">Individual Session</th>
          <th scope="col" *ngFor="let c of uniqueCentres">{{c}}</th>
          <th scope="col"><strong>Total</strong></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of tableData">
          <td>{{ data.teacher }}</td>
          <ng-container *ngFor="let centre of data.centres">
            <td><strong>{{ centre.count }}</strong></td>
          </ng-container>
          <td><strong>{{ getTotalRowCount(data.centres) }}</strong></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td><strong>Total</strong></td>
          <ng-container *ngFor="let centre of uniqueCentres; let i = index">
            <td><strong>{{ getTotalColumnCount(i, tableData) }}</strong></td>
          </ng-container>
          <td><strong>{{ getGrandTotal(tableData) }}</strong></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </section>

  <!-- Group Session Report -->
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Group Session</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportGroupexcel()" permission="Cou. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <table class="table table-striped table-bordered" id="group-table">
        <thead>
        <tr>
          <th scope="col">Group Session</th>
          <th scope="col" *ngFor="let c of groupUniqueCentres">{{c}}</th>
          <th scope="col"><strong>Total</strong></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of groupTableData">
          <td>{{ data.teacher }}</td>
          <ng-container *ngFor="let centre of data.centres">
            <td><strong>{{ centre.count }}</strong></td>
          </ng-container>
          <td><strong>{{ getTotalRowCount(data.centres) }}</strong></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td><strong>Total</strong></td>
          <ng-container *ngFor="let centre of groupUniqueCentres; let i = index">
            <td><strong>{{ getTotalColumnCount(i, groupTableData) }}</strong></td>
          </ng-container>
          <td><strong>{{ getGrandTotal(groupTableData) }}</strong></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </section>

  <!-- Assessment Report -->
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Assessment</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportAssessmentExcel()" permission="Cou. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <table class="table table-striped table-bordered" id="assessment-table">
          <thead>
        <tr>
          <th scope="col">Counsellors</th>
          <th scope="col">Assessment</th>
          <th scope="col" *ngFor="let c of assessmentUniqueCentres">{{c}}</th>
          <th scope="col"><strong>Total</strong></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of assessmentTableData">
          <td>{{ data.teacher }}</td>
          <td>
            Baseline <br>
            Intermediate <br>
            Discharge <br>
          </td>
          <ng-container *ngFor="let centre of data.centres">
            <td>
              {{ centre.admissionBaselineCount }} <br>
              {{ centre.intermediateAssessmentCount }} <br>
              {{ centre.dischargeAssessmentCount }}
            </td>
          </ng-container>
          <td>
              <strong>{{ getTotalAssessmentRowCount(data.centres) }}</strong></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="2"><strong>Total</strong></td>
          <ng-container *ngFor="let centre of assessmentUniqueCentres; let i = index">
            <td><strong>{{ getTotalAssessmentColumnCount(i, assessmentTableData) }}</strong></td>
          </ng-container>
          <td><strong>{{ getGrandAssessmentTotal(assessmentTableData) }}</strong></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </section>

  <!-- Follow Up Assessment Report -->
  <section>
    <div class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Follow Up Sessions</h2>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportFAssessmentExcel()" permission="Cou. Session Count" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
              <img src="assets/images/icons/xlsx.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <table class="table table-striped table-bordered" id="followup-assessment-table">
        <thead>
        <tr>
          <th scope="col">Follow Up Sessions</th>
          <th scope="col" *ngFor="let c of fassessmentUniqueCentres">{{c}}</th>
          <th scope="col"><strong>Total</strong></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of fassessmentTableData">
          <td>{{ data.teacher }}</td>
          <ng-container *ngFor="let centre of data.centres">
            <td><strong>{{ centre.count }}</strong></td>
          </ng-container>
          <td><strong>{{ getTotalRowCount(data.centres) }}</strong></td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td><strong>Total</strong></td>
          <ng-container *ngFor="let centre of fassessmentUniqueCentres; let i = index">
            <td><strong>{{ getTotalColumnCount(i, fassessmentTableData) }}</strong></td>
          </ng-container>
          <td><strong>{{ getGrandTotal(fassessmentTableData) }}</strong></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </section>
</div>
